import { ToggleButtonGroup, ToggleButton, Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

function KsbSelector({
  value,
  onChange,
  options = [],
  getValue,
  getLabel,
  getExtra,
  scrollable = false,
  sx = {},
}) {
  const theme = useTheme();

  const defaultStyles = {
    p: 0.5,
    mr: 2,
    borderRadius: 2,
    backgroundColor: theme.palette.background.paper, // slightly stronger
    border: `1px solid ${theme.palette.background.specialBlack}`,

    "& .MuiToggleButton-root": {
      border: "none",
      textTransform: "none",
      fontWeight: 500,
      px: 1.5,
      borderRadius: 1.5,

      color: "text.secondary",
      transition: "all 0.2s ease",
      whiteSpace: "nowrap",

      "&.Mui-selected": {
        color: "common.white",
        backgroundColor:
          theme.palette.eventManager?.slot?.mine || theme.palette.primary.main,
      },

      "&:hover": {
        backgroundColor: "rgba(255,255,255,0.08)",
      },
    },
  };

  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      size="small"
      onChange={(e, val) => val && onChange(val)}
      sx={{
        ...defaultStyles,

        ...(scrollable && {
          width: "100%",
          maxWidth: "100%",

          display: "flex",
          flexWrap: "nowrap",

          overflowX: "auto",
          overflowY: "hidden",
          border: "2px solid red",

          "&::-webkit-scrollbar": {
            height: 6,
          },

          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "rgba(255,255,255,0.2)",
            borderRadius: 999,
          },
        }),

        ...sx,
      }}
    >
      {options.map((item) => {
        const val = getValue(item);

        return (
          <ToggleButton
            key={val}
            value={val}
            sx={{
              flexShrink: 0,
              opacity: value === val ? 1 : 0.75, // ✅ core change
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
              {getLabel(item)}
              {getExtra && getExtra(item)}
            </Box>
          </ToggleButton>
        );
      })}
    </ToggleButtonGroup>
  );
}

export default KsbSelector;
